<template>
    <div class="container">
        <div class="header">
            <div class="heading">
                <img class="pointer" src="../../assets/backArrow.svg" @click="onBackClick"/>
                <p class="title">User Management</p>
            </div>
        </div>
        <div class="userManagement">
            <div class="subHeading">Basic Details </div>
            <div class="formContainer">
                <div>
                    <div  class="label">Name</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="item.name" placeholder="Enter here" />
                    </div>
                </div>
                <div>
                    <div class="label">User type</div>
                    <div class="content"> 
                        <input disabled class="textbox" :value="roles[item.role]" placeholder="Enter here" />
                    </div>
                </div>
                <div>
                    <div  class="label">Email ID</div>
                    <div class="content"> 
                        <input disabled class="textbox" v-model="item.email" placeholder="Enter here" />
                    </div>
                </div>
            </div>
            <div v-if="item.role === 'SUPERADMIN' || item.role === 'OPS'" class="subHeading">Modify User Access </div>
            <div v-if="item.role === 'SUPERADMIN' || item.role === 'OPS'" style="display: flex; align-items: center; margin-top: 16px">
                <div class="userAccess">Current access: <span style="font-weight: 600; color: #41434C"> {{roles[item.role]}} </span> </div>
                <img class="editIcon" @click="onEditClick(item)" src="../../assets/editIcon.svg" alt="edit">
            </div>
            <div class="subHeading">Revoke access to JioMart Ads Platform </div>
            <div>
                <div v-if="!isRevokeClicked" style="width: 128px" class="submitBtn" @click="onButtonClick">Reactivate account</div>
                <div v-else style="width: 48px; color: #EB5757; border: 1px solid #EB5757" class="submitBtn" @click="onButtonClick">Revoke</div>
            </div>
        </div>
    </div>
    <AccessDialog v-if="showDialog" :isRoleDialog="isRoleDialog" :isRevokeClicked="isRevokeClicked" :item="item" @closeDialog="onDialogClose" @backClicked="onBackClick" />
</template>

<script>
import { roleTypes } from "@/constants"
import AccessDialog from "./AccessDialog"

export default ({
    name: 'UserEdit',
    props: {
        item: Object
    },
    components: {
        AccessDialog
    },
    data() {
        return {
            roles: roleTypes,
            showDialog: false,
            isRoleDialog: false,
            isRevokeClicked: this.item.accountStatus == 'APPROVED' || this.item.accountStatus == 'REACTIVATED',
        }
    },
    methods: {
        onBackClick() {
            this.$emit("backClicked")
        },
        onEditClick() {
            this.showDialog = true;
            this.isRoleDialog = true;
        },
        onDialogClose() {
            this.showDialog = false;
            this.isRoleDialog = false;
        },
        onButtonClick() {
            this.showDialog = true;
        }
    }
})
</script>

<style scoped>
.container {
        font-family: 'Inter-Regular';
        background: #F8F8F8;
        display: flex;
        flex-direction: column;
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        font-family: 'Inter-Regular';
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
        color: #401D0C;
        padding: 8px 20px 0px;
        margin-left: 0;
        background: #FFFFFF;
    }
    .title{
        margin-left:20px;
    }

    .heading {
        display: flex;
        flex-direction: row;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 140%;
        color: #333333;
        margin: 0;
    }
    .userManagement {
        display: flex;
        flex-direction: column;
        margin: 1%;
        text-align: start;
        background: #FFFFFF;
        padding: 22px 24px 36px;
        border-radius: 12px;
    }
    .subHeading {
        font-size: 16px;
        font-weight: 600;
        line-height: 22.4px;
        color: #666666;
        margin-top: 16px;
    }
    .content{
        height: 100%;
        margin-right: 24px;
    }
    .textbox{
        width: 274px;
        padding: 8px 12px;
        font-weight: 400;
        font-size: 12px;
        line-height: 26px;
        background: #FFFFFF;
        border: 1px solid #E0E0E0;
        border-radius: 4px;
        max-width: 246px;
    }
    .label{
        font-weight: 600;
        font-size: 12px;
        line-height: 17px;
        color: #666666;
        margin-bottom: 12px;
        margin-top: 16px;
    }
    .formContainer {
        display: flex;
    }
    .submitBtn{
        font-weight: 700;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
        color: #2E31BE;
        border: 1px solid #2E31BE;
        border-radius: 4px;
        padding: 9.5px 16px;
        cursor: pointer;
        margin-top: 16px;
    }
    .editIcon {
        cursor: pointer;
        width: 16px;
        height: 16px;
        margin-left: 4px;
    }
    .pointer {
        cursor: pointer;
    }
    .userAccess {
        font-weight: 400;
        font-size: 14px;
        color: #9B9B9B
    }
</style>